// 游戏配置
export const GRID_SIZE = 5;
export const INITIAL_MOVES = 25;

// 颜色配置-第一套方案
export const NUMBER_COLORS = [
  '#FFC107', // 0 - 黄色
  '#FF6B6B', // 1 - 红色
  '#4ECDC4', // 2 - 青色
  '#45B7D1', // 3 - 蓝色
  '#8069d0', // 4 - 淡紫色--96CEB4
  '#9C27B0', // 5 - 紫色
  '#FF9800', // 6 - 橙色
  '#607D8B', // 7 - 蓝灰色
  '#8BC34A', // 8 - 淡绿色
  '#F44336', // 9 - 深红色
  '#2196F3', // 10 - 天蓝色
  '#E91E63', // 11 - 粉红色
  '#009688', // 12 - 绿松石色
  '#673AB7', // 13 - 深紫色
  '#3F51B5', // 14 - 靛蓝色
  '#795548', // 15 - 棕色
];

// 明亮活泼风格 --#FFB74D--可以用第二套方案
export const NUMBER_COLORS2= [
  "#FF4C4C", // 鲜红
  "#5C6BC0", // 橘橙
  "#FCC800", // 亮黄
  "#8BC34A", // 亮绿
  "#4CAF50", // 草地绿
  "#00BCD4", // 青色
  "#2196F3", // 蓝色
  "#3F51B5", // 靛蓝
  "#9C27B0", // 紫色
  "#F06292", // 粉红
  "#FF7043", // 珊瑚橙
  "#FFB347", // 蜜蜂黄
  "#26C6DA", // 碧绿
  "#C0CA33", // 芥末绿
  "#607D8B", // 深蓝灰
];

// 获取数字对应的颜色
export const getColorForNumber = (num: number): string => {
  return NUMBER_COLORS[num % NUMBER_COLORS.length];
}; 